import { toast } from 'react-toastify';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

let url = `${process.env.REACT_APP_API_URL}`;
let proxyServer = `${process.env.REACT_APP_MUSICMIND_PROXY_SERVER}`;

const uploadContent = async (token) => {
  const uploadContentUrl = `${proxyServer}/${url}instorex/content/`;

  return await fetch(uploadContentUrl, {
    method: 'GET',
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
    .then(handleResponse)
    .then(videos => {
      return videos;
    })
    .catch(error => {
      if (error === "Unauthorized") {
        cookies.remove('user', { path: '/' });
        cookies.remove('networks', { path: '/' });
        cookies.remove('obtainedBearerToken', { path: '/' });
        cookies.remove('contentPlaylistData', { path: '/' });
        cookies.remove('myDataObject', { path: '/' });
        window.location.reload();
      }
    })
}

const uploadContentSubfolder = async (token, data) => {
  const formData = new FormData();
  formData.append('endpoint', `/${data}`);
  formData.append('nextMarker', '');

  const uploadContentUrl = `${proxyServer}/${url}instorex/content/extended/`;

  return await fetch(uploadContentUrl, {
    method: 'POST',
    body: formData,
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
    .then(handleResponse)
    .then(videos => {
      return videos;
    })
}

const uploadContentPlaylist = async (token) => {
  const uploadContentUrl = `${proxyServer}/${url}instorex/playlist/dynamic/`;

  return await fetch(uploadContentUrl, {
    method: 'GET',
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
    .then(handleResponse)
    .then(contents => {
      return contents;
    })
}

const dynamicContentPlaylistDetail = async (token, id) => {
  const uploadContentUrl = `${proxyServer}/${url}instorex/playlist/dynamic/${id}`;

  return await fetch(uploadContentUrl, {
    method: 'GET',
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
  .then(handleResponse)
  .then(contents => {
    return contents;
  })
}

//save the date and time 
const updateSchedule = async (token, dataContent, storedDataId) => {
  const uploadContentUrl = `${proxyServer}/${url}instorex/playlist/dynamic/content/${storedDataId}`;

  console.log(dataContent);
  
  const dataObj = {
    content: dataContent
  };
  
  return await fetch(uploadContentUrl, {
    method: 'PUT',
    headers: {
      'Authorization': `JWT ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(dataObj)
  })
    .then(handleResponse)
    .then(contents => {
      return contents;
    })
}

const updateContentEndpoint = async (token, data, playlistId) => {
  const dynamicContentUrl = `${proxyServer}/${url}instorex/playlist/dynamic/content/${playlistId}`;

  //set parameters
  let items = [];
  data.map(item => {
    items.push({
      ContentId: item.contentId,
      FileName: item.fileName,
      displayDuration: item.displayDuration === undefined ? '00:00:00' : item.displayDuration,
      ValidityStartDate: item.validityStartDate === undefined ? null : item.validityStartDate,
      ValidityEndDate: item.validityEndDate === undefined ? null : item.validityEndDate
    });
  });

  let contents = {
    content: items 
  }
  return await fetch(dynamicContentUrl, {
    method: 'put',
    body: JSON.stringify(contents),
    headers: {
      'Authorization': `JWT ${token}`,
      'Content-Type': 'application/json'
    }
  })
  .then(handleResponse)
  .then(response => {
    return response;
  })
}

const taggedPlaylists = async (token, data) => {
  const taggedPlaylistUrl = `${proxyServer}/${url}instorex/playlist/tagged/`;

  return await fetch(taggedPlaylistUrl, {
    method: 'get',
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
  .then(handleResponse)
  .then(response => {
    return response;
  })
}

const taggedPlaylistDetail = async (token, id) => {
  const taggedPlaylistUrl = `${proxyServer}/${url}instorex/playlist/tagged/${id}`;

  return await fetch(taggedPlaylistUrl, {
    method: 'get',
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
  .then(handleResponse)
  .then(response => {
    return response;
  })
}

const taggedContentUnitList = async (token, marker) => {
  const taggedContentUnitListUrl = `${proxyServer}/${url}instorex/devices/`;
  const formData = new FormData();
  formData.append('nextMarker', `?marker=${marker}`);

  return await fetch(taggedContentUnitListUrl, {
    method: 'post',
    body: formData,
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
  .then(handleResponse)
  .then(response => {
    return response;
  })
}

const unitPropertyDetails = async (token, id) => {
  const unitPropertyDetailsUrl = `${proxyServer}/${url}instorex/devices/${id}`;

  return await fetch(unitPropertyDetailsUrl, {
    method: 'get',
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
  .then(handleResponse)
  .then(response => {
    return response;
  })
}

const unitPropertyDownloads = async (token, id) => {
  const unitPropertyDownloadsUrl = `${proxyServer}/${url}instorex/devices/downloads/${id}`;

  return await fetch(unitPropertyDownloadsUrl, {
    method: 'get',
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
  .then(handleResponse)
  .then(response => {
    return response;
  })
}

const unitPropertyErrorLogs = async (token, id) => {
  const unitPropertyErrorLogsUrl = `${proxyServer}/${url}instorex/devices/errors/${id}`;

  return await fetch(unitPropertyErrorLogsUrl, {
    method: 'get',
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
  .then(handleResponse)
  .then(response => {
    return response;
  })
}

const unitPropertySnapshots = async (token, id) => {
  const unitPropertySnapshotsUrl = `${proxyServer}/${url}instorex/devices/screenshots/${id}`;

  return await fetch(unitPropertySnapshotsUrl, {
    method: 'get',
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
  .then(handleResponse)
  .then(response => {
    return response;
  })
}

const groupListFetch = async (token) => {
  const groupsListUrl = `${proxyServer}/${url}instorex/groups/`;
  const formData = new FormData();
  formData.append('nextMarker', '');

  return await fetch(groupsListUrl, {
    method: 'post',
    body: formData,
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
  .then(handleResponse)
  .then(response => {
    return response;
  })
}

const groupDetailFetch = async (token, id) => {
  const groupsListUrl = `${proxyServer}/${url}instorex/groups/${id}`;

  return await fetch(groupsListUrl, {
    method: 'get',
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
  .then(handleResponse)
  .then(response => {
    return response;
  })
}

const handleResponse = async response => {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        cookies.remove('user');
        window.location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    else if(response.status === 201) {
      toast.success('Gemt succes');
    }
    return data;
  });
}

const getMusicPlaylist = async (token) => {
  const playlistUrl = `${proxyServer}/${url}music/playlist`;

  return await fetch(playlistUrl, {
    method: 'GET',
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
    .then(async (response) => {
      return await response.json();
    })
    .then(playlist => {
      return playlist;
    })
}

const uploadSendPlaylistToDevice = async (token, playlist) => {
  const formData = new FormData();
  formData.append('playlist', playlist);

  const uploadContentUrl = `${proxyServer}/${url}instorex/content/extended/`;

  return await fetch(uploadContentUrl, {
    method: 'POST',
    body: formData,
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
    .then(handleResponse)
    .then(videos => {
      return videos;
    })
}

const getPresentations = async (token) => {
  const presentationsUrl = `${proxyServer}/${url}instorex/presentations/`;

  return await fetch(presentationsUrl, {
    method: 'GET',
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
    .then(handleResponse)
    .then(presentation => {
      return presentation.items;
    })
}

const addPresentation = async (token, presentationParams) => {
  const presentationsUrl = `${proxyServer}/${url}instorex/presentations/`;
  const formData = new FormData();
  formData.append('name', presentationParams.presentationName);
  formData.append('overscan', presentationParams.overscanValue);
  formData.append('connector', presentationParams.connectorType);
  formData.append('videoMode', presentationParams.videoMode);
  formData.append('orientation', presentationParams.monitorOrientation);
  return await fetch(presentationsUrl, {
    method: 'POST',
    body: formData,
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
    .then(handleResponse)
    .then(presentation => {
      return presentation.items;
    })
}

const updatePresentation = async (token, presentationParams, id) => {
  const presentationsUrl = `${proxyServer}/${url}instorex/presentations/${id}`;
  const formData = new FormData();
  formData.append('name', presentationParams.presentationName);
  formData.append('overscan', presentationParams.overscanValue);
  formData.append('connector', presentationParams.connectorType);
  formData.append('videoMode', presentationParams.videoMode);
  formData.append('orientation', presentationParams.monitorOrientation);
  return await fetch(presentationsUrl, {
    method: 'POST',
    body: formData,
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
    .then(handleResponse)
    .then(presentation => {
      return presentation.items;
    })
}

const addDynamicPlaylist = async (token, playlistParams) => {
  const playlistUrl = `${proxyServer}/${url}instorex/playlist/dynamic/`;
  const formData = new FormData();
  formData.append('name', playlistParams.playlistName);
  return await fetch(playlistUrl, {
    method: 'POST',
    body: formData,
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
    .then(handleResponse)
    .then(playlist => {
      return playlist.items;
    })
}

const updateDynamicPlaylist = async (token, playlistParams, id) => {
  const playlistUrl = `${proxyServer}/${url}instorex/playlist/dynamic/${id}`;
  const formData = new FormData();
  formData.append('name', playlistParams.playlistName);
  return await fetch(playlistUrl, {
    method: 'POST',
    body: formData,
    headers: {
      'Authorization': `JWT ${token}`
    }
  })
    .then(handleResponse)
    .then(playlist => {
      return playlist.items;
    })
}

export const uploadContentService = {
  taggedPlaylists,
  uploadContent,
  uploadContentSubfolder,
  uploadContentPlaylist,
  dynamicContentPlaylistDetail,
  updateSchedule,
  updateContentEndpoint,
  taggedPlaylistDetail,
  taggedContentUnitList,
  groupListFetch,
  groupDetailFetch,
  unitPropertyDetails,
  unitPropertyDownloads,
  unitPropertyErrorLogs,
  unitPropertySnapshots,
  getMusicPlaylist,
  uploadSendPlaylistToDevice,
  getPresentations,
  addPresentation,
  updatePresentation,
  addDynamicPlaylist,
  updateDynamicPlaylist,
  proxyServer
}